import toast from 'react-hot-toast';

import useEmail from '~/hooks/useEmail';

interface Props {
  formId: string;
  shouldConsentToTOS: boolean;
  onError: () => void;
  fetcher: any;
}

interface ReturnProps {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const useSignupSubmit = ({ formId, shouldConsentToTOS, onError, fetcher }: Props): ReturnProps => {
  const [, setEmail] = useEmail();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    window._pxFormId = formId;

    const tosConsented = formData.get('tos_consent');
    if (shouldConsentToTOS && !tosConsented) {
      toast.error('Accept ToU & Privacy Policy.');
      onError();
      return;
    }

    const trimmedEmail = (formData.get('email') || '')?.toString().trim();
    // We get a lot of headless bots that submit empty emails. This will remove those from actual submissions and processed sentry errors.
    if (!trimmedEmail) {
      toast.error('Please enter a valid email address');
      onError();
      return;
    }

    // Store email in localStorage before submitting so it's available for signup redirects
    setEmail(trimmedEmail);

    formData.set('accepted_tos', String(tosConsented));
    formData.set('email', trimmedEmail);

    fetcher.submit(formData, {
      method: 'post',
      action: '/create',
    });
  };

  return {
    handleSubmit,
  };
};

export default useSignupSubmit;
